import { useQueryClient } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { FC, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getGetCurrentUserQueryKey } from "~/api/users/users";
import { removeAllTokens, storeAccessToken } from "~/helpers";
import { useAuthStore } from "~/stores/authStore";
import { setCookie } from "~/utils/cookies";

export const ImpersonatePage: FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!token) return;

    removeAllTokens();
    queryClient.setQueryData(getGetCurrentUserQueryKey(), null);
    queryClient.clear();

    storeAccessToken(token);

    setCookie("skyImpersonating", "true");
    useAuthStore.getState().setImpersonating(true);
    useAuthStore.getState().setAuthExpired(false);

    navigate("/", { replace: true });
  }, [token, navigate, queryClient]);

  return (
    <div className="flex h-screen items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-gray-400" />
    </div>
  );
};
